export const FETCH_CHECKOUT_CAMPAIGN_REPORTS =
  "FETCH_CHECKOUT_CAMPAIGN_REPORTS";
export const FETCH_CHECKOUT_CAMPAIGN_REPORTS_SUCCESS =
  "FETCH_CHECKOUT_CAMPAIGN_REPORTS_SUCCESS";
export const FETCH_CHECKOUT_CAMPAIGN_REPORTS_ERROR =
  "FETCH_CHECKOUT_CAMPAIGN_REPORTS_ERROR";
